import { QuizSubmitBody, SubmitQuizResponse } from '../../../interfaces/api/quiz';
import { services } from '../../../api';
import { Result } from '../../../shared/utils/enums';

/**
 * Submits quiz answers to the server.
 *
 * @param {number} quizId - The ID of the quiz.
 * @param {QuizSubmitBody[]} answers - The answers to submit.
 * @returns {Promise<SubmitQuizResponse | null>} The server response if successful, otherwise `null`.
 */
export const submitQuiz = async (quizId: number, answers: QuizSubmitBody[]): Promise<SubmitQuizResponse | null> => {
  try {
    const res = await services.quiz.submitQuiz(quizId, answers);
    return res.result === Result.Success ? res.content : null;
  } catch (error) {
    console.error('Quiz submission error:', error);
    return null;
  }
};
